import { render, staticRenderFns } from "./boardRoom.vue?vue&type=template&id=b0dafc38&scoped=true&"
import script from "./boardRoom.vue?vue&type=script&lang=js&"
export * from "./boardRoom.vue?vue&type=script&lang=js&"
import style0 from "./boardRoom.vue?vue&type=style&index=0&id=b0dafc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dafc38",
  null
  
)

export default component.exports